import { storableError } from '../../util/errors';

import { pickListingForEdit } from './EditListingTabShortcutPage.helpers';

// Re-export for callers that import selection from the duck.
export { pickListingForEdit };

// ================ Action types ================ //

export const QUERY_OWN_LISTINGS_REQUEST =
  'app/EditListingTabShortcutPage/QUERY_OWN_LISTINGS_REQUEST';
export const QUERY_OWN_LISTINGS_SUCCESS =
  'app/EditListingTabShortcutPage/QUERY_OWN_LISTINGS_SUCCESS';
export const QUERY_OWN_LISTINGS_ERROR = 'app/EditListingTabShortcutPage/QUERY_OWN_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  queryInProgress: false,
  queryError: null,
  ownListings: [],
};

export default function editListingTabShortcutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case QUERY_OWN_LISTINGS_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryError: null,
        ownListings: [],
      };
    case QUERY_OWN_LISTINGS_SUCCESS:
      return {
        ...state,
        queryInProgress: false,
        ownListings: payload.ownListings,
      };
    case QUERY_OWN_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryError: payload, ownListings: [] };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const queryOwnListingsRequest = () => ({ type: QUERY_OWN_LISTINGS_REQUEST });

export const queryOwnListingsSuccess = ownListings => ({
  type: QUERY_OWN_LISTINGS_SUCCESS,
  payload: { ownListings },
});

export const queryOwnListingsError = e => ({
  type: QUERY_OWN_LISTINGS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const queryOwnListings = () => (dispatch, getState, sdk) => {
  dispatch(queryOwnListingsRequest());

  return sdk.ownListings
    .query({ page: 1, perPage: 100 })
    .then(response => {
      const ownListings = response?.data?.data || [];
      dispatch(queryOwnListingsSuccess(ownListings));
      return response;
    })
    .catch(e => {
      dispatch(queryOwnListingsError(storableError(e)));
      // Do not rethrow: the page redirects to ManageListingsPage on queryError.
    });
};

export const loadData = () => dispatch => dispatch(queryOwnListings());
